<template>
	<div>
		<footer class="footer">
			<div class="row-1">
				<div class="container_1200">
					<div class="company">
						<div class="logo">
							<img src="/static/white_logo.png" alt="" />
						</div>
						<div class="tel">
							<img src="/static/icon_eat2.png" alt="" />
							<div class="value">
								{{company.phone}}
							</div>
							<div class="clear"></div>
						</div>
						<div class="address">
							地址：{{company.address}}
						</div>
					</div>
					<div class="nav">
						<div class="block_title">
							- 快速导航
						</div>
						<ul>
							<li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'on':''"
								@click="navClick(index,item.name)">
								<router-link :to="item.path">
									<div class="title">
										{{item.name}}
									</div>
								</router-link>
							</li>
							<div class="clear"></div>
						</ul>
					</div>
					<div class="qrcode">
						<div class="block_title">
							- 关注我们
						</div>
						<ul>
							<li> <img :src="company.wxQrcode" alt="">
								<p>微信公众号</p>
							</li>
							<li> <img src="/static/sp.jpg" alt="">
								<p>视频号</p>
							</li>
							<li> <img :src="company.dyQrcode" alt="">
								<p>抖音号</p>
							</li>

							<div class="clear"></div>
						</ul>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="row-2">
				<div class="container_1200">
					<p class="copy">{{company.copyright}}</p>
					<p> <a href="https://beian.miit.gov.cn/" target="_blank">{{company.icpNo}}</a> &nbsp;&nbsp;&nbsp;
					</p>
				</div>
			</div>
		</footer>
		<!-- <div class="fixed_fill" style="height: 92px;"></div>
    <div class="fixed_container">
      <div class="container_1000">
        <div class="info fl">
          <div class="title">
            一次投资，长期受益
          </div>
          <div class="desc">
            留下您的电话，我们将第一时间与您联系
          </div>
        </div>
        <div class="form_content fr">
          <div class="inp fl">
            <input type="text" id="feedback_name" v-model="name" placeholder="姓名">
          </div>
          <div class="inp fl">
            <input type="text" id="feedback_mobile" v-model="mobile" placeholder="手机号">
          </div>
          <div class="submit fl feedback_submit" @click="submit">
            提 交
          </div>
          <img class="del" src="images/close_01.png" alt="">
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div> -->
	</div>
	</div>
</template>
<script>
	// import config from '@/config'
	import {
		Message
	} from 'element-ui'
	export default {
		name: "Footer",
		data() {
			return {
				navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
				company: JSON.parse(localStorage.getItem('company')),
				navList: [{
						name: "首页",
						path: "/",
						children: []
					},
					{
						name: "硬件产品",
						path: "/operate",
					},
					{
						name: "案例中心",
						path: "/case_center",
						children: []
					},
					{
						name: "业务合作",
						path: "/business",
						children: []
					},
					{
						name: "新闻资讯",
						path: "/news",
						children: []
					},
					{
						name: "联系我们",
						path: "/aboutus?id=4",
						children: []
					}
				],
				name: '',
				mobile: ''

			};
		},
		methods: {
			navClick(index, name) {
				this.navIndex = index;
				sessionStorage.setItem('navIndex', index)
				this.menuName = name;
				setTimeout(function() {
					location.reload()
				}, 100)
			},
			submit() {
				if (this.name == '') {
					this.$message({
						message: '请输入姓名',
						type: 'warning'
					});
					return
				}
				if (this.mobile == '') {
					this.$message({
						message: '请输入手机号',
						type: 'warning'
					});
					return
				}
			}

		},
	};
</script>
<style scoped>
	a:focus,
	a:hover {
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue